import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { isMobile } from 'react-device-detect';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { Tooltip as ReactTooltip } from "react-tooltip";

// Components
import Header from "../../components/Header";
import Footer from "../../components/Home/Footer";
import Menu from "../../components/Home/Menu";
import NossosServicos from "../../components/Home/NossosServicos";

//Imagens
import img from './img/bg.png';
import pdf from './img/pdf.png'

// Styles
import './Lgpd.scss';
import 'react-tooltip/dist/react-tooltip.css'
import { useNavigationIdz } from '../../context/useNavigation';



function Lgpd() {
    const { idzOrigin, idzEvent, loading } = useNavigationIdz();

    useEffect(() => {
        if (!loading) {
            idzOrigin(window.location.href);
            idzEvent("paginas_acessadas", "Lgpd");
        }
    }, [loading]);

    return (
        <>
            <Menu />
            <Header />
            <section className='BannerLgpd'>
                <Container>
                    <Row className='justify-content-md-center'>
                        <Col xs={12} sm={12} md={12} lg={8} className='boxBannerInstitucional'>
                            <div className='textBannerInstitucional'>
                                <h3>LGPD</h3>
                                <h2>Políticas de Privacidade <br/> do Grupo 1021</h2>
                                <p>Em conformidade com a Lei Geral de Proteção de Dados (LGPD), disponibilizamos as políticas de privacidade de cada uma das empresas do nosso grupo. Você pode consultar e baixar cada uma delas abaixo.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
                <section className="lgpd-section">
                <Container>
                    <h2 className="lgpd-title">
                    <strong>DOCUMENTOS DISPONÍVEIS</strong> PARA DOWNLOAD
                    </h2>
                    <Row className="g-4">
                    {[
                        {
                            title: '1021 MOTORS',
                            subtitle: 'DECLARAÇÃO DE POLÍTICA DE PRIVACIDADE',
                            description:
                            'Documento principal de referência do grupo, descreve os fundamentos legais, princípios e procedimentos adotados pela 1021 Motors para o tratamento e proteção de dados pessoais em conformidade com a LGPD.',
                            link: 'http://idzagencia.com.br/clientes/1021/Declaraccao-da-Política-de-Tratamento-de-Dados-1021Motors.pdf',
                        },
                        {
                            title: '1021 CONSULTING',
                            subtitle: 'DECLARAÇÃO DE PRIVACIDADE E TRATAMENTO DE DADOS',
                            description:
                            'Declaração voltada aos serviços da 1021 Consulting, com foco na coleta, tratamento e governança de dados pessoais no contexto de consultorias e operações empresariais especializadas.',
                            link: 'http://idzagencia.com.br/clientes/1021/1021-CONSULTING-Declaracao.pdf',
                        },
                        {
                            title: '1021 PERFORMANCE',
                            subtitle: 'DECLARAÇÃO DE TRATAMENTO DE DADOS PESSOAIS',
                            description:
                            'Documento que formaliza o compromisso da 1021 Performance com a privacidade e proteção de dados, especialmente em operações logísticas, transporte e serviços operacionais.',
                            link: 'http://idzagencia.com.br/clientes/1021/1021-Performance-Declaracao.pdf',
                        },
                        {
                            title: '1021 CORRETORA',
                            subtitle: 'DECLARAÇÃO DE PRIVACIDADE – SETOR DE SEGUROS',
                            description:
                            'Documento detalhado sobre a política de tratamento de dados sensíveis e financeiros pela 1021 Premium Corretora de Seguros, com foco em conformidade legal e proteção de informações de clientes.',
                            link: 'http://idzagencia.com.br/clientes/1021/1021-Premium-Corretora-Declaracao.pdf',
                        }
                        ].map((doc, i) => (
                        <Col key={i} xs={12} md={6}>
                        <div className="lgpd-card">
                            <div className="lgpd-card-header">
                            <img src={pdf} alt="PDF" />
                            <div>
                                <h3>{doc.title}</h3>
                                <p className="subtitle">{doc.subtitle}</p>
                            </div>
                            </div>
                            <p className="description">{doc.description}</p>
                            <a
                            href={doc.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-download"
                            >
                            BAIXAR PDF
                            </a>
                        </div>
                        </Col>
                    ))}
                    </Row>
                </Container>
                </section>
                <NossosServicos />
            <Footer />
        </>
    );
}

export default Lgpd;